import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Heading,
    Spinner,
    Text,
    VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { resolveIcd10ByCpts } from "../../../../api"; // your existing function
import RequisitionFieldRenderer from "../RequisitionFieldRenderer"; // your renderer

export default function PanelSelect({ panels }) {
    const [selectedPanel, setSelectedPanel] = useState(null);
    const [panelTests, setPanelTests] = useState([]);
    const [loadingIdx, setLoadingIdx] = useState(null);

    const handleSelectPanel = async (opt) => {
        setSelectedPanel(opt);
        if (opt) {
            // initialize empty tests first
            const init = opt.tests.map((t) => ({
                test: t,
                icdOptions: [],
                icdSelected: null,
                requisitionValues: {},
            }));
            setPanelTests(init);

            // fetch ICD-10 for each test
            opt.tests.forEach(async (t, idx) => {
                if (t.cpts?.length) {
                    setLoadingIdx(idx);
                    const res = await resolveIcd10ByCpts(t.cpts);
                    console.log(res)
                    setPanelTests((prev) => {
                        const copy = [...prev];
                        copy[idx].icdOptions = res.success
                            ? res.data?.icd10?.map((icd) => ({
                                value: icd.code,
                                label: icd.code,
                                ...icd
                            }))
                            : [];
                        return copy;
                    });
                    setLoadingIdx(null);
                }
            });
        } else {
            setPanelTests([]);
        }
    };

    const updateIcd = (idx, code) => {
        const copy = [...panelTests];
        copy[idx].icdSelected = code;
        setPanelTests(copy);
    };

    const updateRequisitionField = (idx, key, val) => {
        const copy = [...panelTests];
        copy[idx].requisitionValues = {
            ...copy[idx].requisitionValues,
            [key]: val,
        };
        setPanelTests(copy);
    };

    return (
        <>

            <Select
                options={panels}
                value={selectedPanel}
                onChange={handleSelectPanel}
                placeholder="Select panel"
                isClearable
            />
            {selectedPanel && (
                <Box mt={6} p={4} borderWidth="1px" borderRadius="md">
                    <Heading size="md" mb={2}>
                        {selectedPanel.name}
                    </Heading>
                    <Text mb={4}>{selectedPanel.description}</Text>

                    <Heading size="sm" mb={2}>
                        Tests in Panel
                    </Heading>
                    <VStack align="stretch" spacing={4}>
                        {panelTests.map((sel, idx) => (
                            <Box
                                key={sel.test._id}
                                p={3}
                                borderWidth="1px"
                                borderRadius="md"
                            >
                                <Heading size="sm" mb={2}>
                                    {sel.test.name}
                                </Heading>
                                <Text fontSize="sm" color="gray.600" mb={2}>
                                    Code: {sel.test.code} | CPTs: {sel.test.cpts.join(", ")}
                                </Text>

                                {/* ICD-10 selector */}
                                <FormControl mb={3}>
                                    <FormLabel>ICD-10 Code</FormLabel>
                                    {loadingIdx === idx ? (
                                        <Spinner size="sm" />
                                    ) : (
                                        <CreatableSelect
                                            isClearable
                                            options={sel.icdOptions}
                                            value={sel.icdSelected}
                                            onChange={(code) => updateIcd(idx, code)}
                                            placeholder="Select or type ICD-10 code"
                                        />
                                    )}
                                </FormControl>

                                {/* Requisition schema */}
                                {sel.test.requisitionSchema?.fields?.length > 0 && (
                                    <Box mt={3}>
                                        <Heading size="xs" mb={2}>
                                            {sel.test.requisitionSchema.title || "Requisition"}
                                        </Heading>
                                        {sel.test.requisitionSchema.fields.map((f) => (
                                            <RequisitionFieldRenderer
                                                key={f.key}
                                                field={f}
                                                value={sel.requisitionValues[f.key]}
                                                onChange={(val) =>
                                                    updateRequisitionField(idx, f.key, val)
                                                }
                                            />
                                        ))}
                                    </Box>
                                )}
                            </Box>
                        ))}
                    </VStack>

                    <Box mt={6}>
                        <Button colorScheme="blue" size="sm">
                            Save Panel Tests
                        </Button>
                    </Box>
                </Box>
            )}
        </>
    );
}
